import React from "react";
const IconUvProtection = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54" {...props}>
    <path
      d="M30 36.403a10.481 10.481 0 0 1-3.5.597C20.701 37 16 32.299 16 26.5S20.701 16 26.5 16c5.29 0 9.666 3.912 10.394 9M24.133 5.634l.879 6.3m4.322 30.974.879 6.3M48.96 24.38l-6.3.879m-30.974 4.322-6.3.879M44.52 13.895l-5.016 3.911m-24.663 19.23-5.017 3.912m7.733-25.858-3.911-5.017M35.431 7.034l-2.389 5.896M21.298 41.915l-2.388 5.896m-6.232-26.26-5.896-2.39"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M37 24.332c2.111 2.639 5.507 4.56 9 5.314C46 41.5 37 45 37 45s-9-3.5-9-15.354c3.493-.755 6.889-2.674 9-5.313Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M31.39 32.5c.934 4.39 3.353 6.95 5.11 8.285" stroke="currentColor" strokeWidth="2" />
  </svg>
);
export default IconUvProtection;
